import { Injectable } from '@angular/core';
import { ConfigSetting } from 'src/app/core/models/config-settings.model';
import { LocalStorage } from 'src/app/core/storage/local-storage/local-storage';
import { LocalStorageService } from 'src/app/core/storage/local-storage/local-storage.service';

@Injectable({
	providedIn: 'root'
})
export class ClientConfigurationService {

	table = 'configSettings';
	private store: LocalStorage;

	constructor(
		private storage: LocalStorageService,
	) {
		this.store = this.storage[this.table];
	}

	async hasFeature(featureName: string): Promise<boolean> {
		const feature = await this.getSetting(featureName);
		if (!feature) {
			return false;
		}
		if (typeof (feature.value) == 'string') {
			feature.value = feature.value.toLowerCase() === 'true';
		}
		return !!feature.value;
	}

	async getSetting(settingName: string): Promise<ConfigSetting> {
		return await this.store.getItem<ConfigSetting>(settingName);
	}

}
